import {
  useEffect,
  useState,
  type ChangeEventHandler,
  type FocusEventHandler,
} from 'react'
import { useDebounce } from '~/@lib/utils/function.utils'

const PARTIAL_VALUE_REGEX = /^[0-9]*[,.]?[0-9]{0,2}$/

type Props = {
  minOrder: number
  maxOrder: number
}

export const useInvestmentInput = ({ minOrder, maxOrder }: Props) => {
  const [numberValue, setNumberValue] = useState(minOrder)
  const [sliderValue, setSliderValue] = useState(minOrder)
  const [value, setValue] = useState(minOrder.toFixed(2))
  const { debounce } = useDebounce(100)

  // TODO: WOF campaign
  // const [specialBonus, setSpecialBonus] = useState<SpecialBonus | null>(null);

  const handleInvestmentValueChanged = (amount: number) => {
    setValue(amount.toFixed(2))
    setSliderValue(amount)
    setNumberValue(amount)
  }
  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const normalizedValue = event.target.value.replace(/\s/g, '').trim()

    if (normalizedValue === '') {
      setValue('')
      setSliderValue(0)
      setNumberValue(0)
      return
    }

    if (PARTIAL_VALUE_REGEX.test(normalizedValue)) {
      const rawNumberValue = normalizedValue
        ? Math.round(Number(normalizedValue.replace(',', '.')) * 100) / 100
        : 0

      const minMaxNumValue = Math.max(0, Math.min(maxOrder, rawNumberValue))

      setValue(
        minMaxNumValue.toLocaleString('sk-SK', {
          useGrouping: true,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      )

      debounce(() => {
        setSliderValue(minMaxNumValue)
        setNumberValue(minMaxNumValue)
      })
    }
  }

  const handleBlur: FocusEventHandler<HTMLInputElement> = () => {
    const cleanValue = value.replace(/\s/g, '').trim()

    if (cleanValue === '') {
      setValue('')
      setSliderValue(0)
      setNumberValue(0)
      return
    }

    setValue(
      numberValue.toLocaleString('sk-SK', {
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    )
    setSliderValue(numberValue)
  }

  const handleSliderChange = (_: any, _value: unknown) => {
    if (typeof _value !== 'number') {
      return
    }
    const newValue = Math.round(10 ** _value)
    setSliderValue(newValue)
  }

  useEffect(() => {
    if (sliderValue !== numberValue) {
      setNumberValue(sliderValue)
      setValue(
        sliderValue.toLocaleString('sk-SK', {
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      )
    }
  }, [sliderValue, numberValue])

  // because the handleSliderChange function is triggered too many times, changes from slider has to be debounced
  // useDebounce(
  //   () => {
  //     if (sliderValue !== numberValue) {
  //       setNumberValue(sliderValue)
  //       setValue(sliderValue.toFixed(2))
  //     }
  //   },
  //   10,
  //   [sliderValue]
  // )

  return {
    investmentInputValue: value,
    investment: numberValue,
    sliderValue,
    handleSliderChange,
    handleChange,
    handleInvestmentValueChanged,
    handleBlur,
    // specialBonus,
    // setSpecialBonus
  }
}
